export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'name', label: 'Name' },
  { name: 'salesforce_id', label: 'Salesforce ID' },
  { name: 'two_factor_authentication', label: '2FA for all users', type: 'boolean' },
]



// WEBPACK FOOTER //
// ./src/fields/companies.js